module.exports = __webpack_public_path__ + "static/media/d8ru.1ac04100.pdf";